import React from 'react'
import { useParams } from 'react-router-dom';
import Topbar from '../layouts/Topbar';
import Orders from '../pages/Orders';
import Staff from '../pages/Staff';
import Payment from '../pages/Payment';
import Consultation from '../pages/Consultation';

const Reports_component = () => {
    const { type } = useParams();
    return (
        <div>
            {/* <h1>{type}</h1> */}
            {type === 'orders' ?
                <Orders /> :
                type === 'Consultation' ?
                    <Consultation /> :
                    type === 'Payments' ?
                        <Payment /> :
                        type === 'Staff' ?
                            <Staff /> : <Staff />
            }
        </div>
    )
}

export default Reports_component